import './Main.scss';
import HeaderSection from './HeaderSection/HeaderSection';
import MainSection from "./MainSection/MainSection";
import PortfolioSection from "./PortfolioSection/Portfolio";
import ContactSection from "./ContactSection/ContactSection";
import AboutUsSection from "./AboutUsSection/AboutUs";
import FeedbackSection from "./FeedbackSection/FeedbackSection";
import LandingWhatWeDo from "./WhatWeDoSection/WhatWeDoSection";
import {useEffect, useRef} from "react";
import {useCookies} from "react-cookie";
import CookieConsent from "./CookiesSection/CookieConsent";
import {useLocation} from "react-router-dom";

const Main = () => {
  const headerRef = useRef(null);
  const [cookies] = useCookies(["cookieConsent"]);
  const location = useLocation();

  const scrollToHeader = () => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

  return (
    <div>
      <HeaderSection />
      <MainSection ref={headerRef}/>
      <LandingWhatWeDo/>
      <AboutUsSection/>
      {/*<PortfolioSection/>*/}
      {/*<FeedbackSection/>*/}
      <ContactSection scrollToHeader={scrollToHeader}/>
      {!cookies.cookieConsent && <CookieConsent/>}
    </div>
  );
}

export default Main;

